<template>

  <section class="formWrapper">

    <form class="form">

      <header>

        <img src="@/assets/jhl-logo.png" class="logo" alt="JHL logo" />

        <button class="logOut" @click.prevent="logout()"></button>

      </header>

      <h1>JHL – valmistuvat opiskelijajäsenet</h1>
      <!--<h2>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris rhoncus dapibus iaculis. Suspendisse et finibus odio, eu finibus mi. Etiam quam felis, maximus ac augue vitae, euismod mattis massa. Phasellus porta sollicitudin maximus.</h2>-->

      <div class="qWrapper">

        <label>Haluan liittyä Julkisten ja hyvinvointialojen työttömyyskassaan</label>

        <div class="inputWrapper">

          <div class="checkbox">
            <input type="checkbox" v-model="form.wannaJoin" />
            <div class="checked"></div>
            <div class="checkedBG"></div>
          </div>

        </div>

      </div>

      <div class="qWrapper">

        <label>Koko nimi:</label>
        <input type="text" v-model="form.name" />

      </div>

      <div class="qWrapper">

        <label>Jäsennumero:</label>
        <input type="text" v-model="form.memberNumber" />

      </div>

      <div class="qWrapper">

        <label>Sähköposti:</label>
        <input type="text" v-model="form.email" />

      </div>

      <div class="qWrapper">

        <label>Työnantajan nimi:</label>
        <input type="text" v-model="form.employer" />

      </div>

      <div class="qWrapper">

        <label>Työpaikan nimi:</label>
        <input type="text" v-model="form.emplyerName" />

      </div>

      <div class="qWrapper">

        <label>Työsuhteen alkupäivä:</label>
        <input type="text" v-model="form.startDate" />

      </div>

      <div class="qWrapper">

        <label>Määräaikaisen työsuhteen päättymispäivämäärä:</label>
        <input type="text" v-model="form.endDate" />

      </div>

      <div class="qWrapper">

        <label>Ammattinimike:</label>
        <input type="text" v-model="form.title" />

      </div>


      <div class="qWrapper">

        <label>Omistatko itse tai omistaako perheesi kokonaan tai osittain yrityksen jossa työskentelet?</label>

        <div class="inputWrapper">

          <div class="checkbox">
            <input type="checkbox" v-model="form.businessOwner" />
            <div class="checked"></div>
            <div class="checkedBG"></div>
          </div>

        </div>

      </div>

      <div class="qWrapper" v-if="form.businessOwner">

        <label>Omistusosuus yrityksestä (%):</label>
        <input type="text" v-model="form.businessOwnerPercentage" />

      </div>

      <div class="qWrapper">

        <label>Liitto/työttömyyskassa, josta siirryn:</label>
        <input type="text" v-model="form.previousUnion" />

      </div>

      <div class="qWrapper">

        <label>Valtuutan JHL:n irtisanomaan jäsenyytesi edellisestä liitosta/työttömyyskassasta ja pyytämään tarvittaessa jäsenyystietoni:</label>

        <div class="inputWrapper">

          <div class="checkbox">
            <input type="checkbox" v-model="form.canTerminate" />
            <div class="checked"></div>
            <div class="checkedBG"></div>
          </div>

        </div>

      </div>

      <div class="qWrapper">

        <label>Haluan, että työnantajani perii jäsenmaksun suoraan palkasta ( Jätä valitsematta jos maksat itse):</label>

        <div class="inputWrapper">

          <div class="checkbox">
            <input type="checkbox" v-model="form.fromPay" />
            <div class="checked"></div>
            <div class="checkedBG"></div>
          </div>

        </div>

      </div>

      <div class="qWrapper">

        <label>Valtuutan JHL:n siirtämään minut oikeaan yhdistykseen työsuhdetietojeni perusteella:</label>

        <div class="inputWrapper">

          <div class="checkbox">
            <input type="checkbox" v-model="form.canTransfer" />
            <div class="checked"></div>
            <div class="checkedBG"></div>
          </div>

        </div>

      </div>

      <div class="qWrapper">

        <label>Mihin lomake lähetetään:</label>

        <select v-model="form.sendDestination">
          <option value="null">Valitse</option>
          <option value="0">Etelä-Suomi</option>
          <option value="1">Sisä-Suomi</option>
          <option value="2">Varsinais-Suomi</option>
          <option value="3">Satakunta</option>
          <option value="4">Kaakkois-Suomi</option>
          <option value="5">Itä-Suomi</option>
          <option value="6">Oulu</option>
          <option value="7">Lappi</option>
          <option value="8">Pohjanmaa</option>
          <option value="9">Anni Järvinen</option>
        </select>

      </div>

      <div class="qWrapper">

        <label>Lisätietoja (esim. maininta maksuvapautuksesta):</label>

        <textarea v-model="form.additionalInfo"></textarea>

      </div>

      <button class="sendForm" @click.prevent="send()" :class="{ sendFormLoading : loading }">Lähetä lomake</button>

    </form>

  </section>

</template>

<script>
import "@/helpers/firebaseConf"
import firebase from "firebase/app";
import "firebase/functions";

export default {
  data() {
    return {
      loading: false,
      form: {
        wannaJoin: false,
        name: "",
        memberNumber: "",
        email: "",
        employer: "",
        emplyerName: "",
        startDate: "",
        endDate: "",
        title: "",
        businessOwner: false,
        businessOwnerPercentage: "",
        previousUnion: "",
        canTerminate: false,
        fromPay: false,
        canTransfer: false,
        sendDestination: null,
        additionalInfo: ""
      }
    }
  },
  methods: {

    send() {
      var _this = this;

      if(!_this.form.sendDestination) return alert("Valitse kenelle lomake lähetetään.")

      _this.loading = true;

      var test = firebase.functions().httpsCallable('sendEmail');
        test(_this.form).then(function(result) {
          _this.loading = false;

          if( result.data.result != 200 ) {
            alert("Jotain meni vikaan, yritä uudelleen.")
          } else {
            alert("Lomake lähetetty!")
            location.reload();
          }

        }).catch(function(error) {
          alert("Jotain meni vikaan, yritä uudelleen.")
          console.log(error)
        });

    },

    logout() {
      var self = this;

      firebase.auth().signOut().then(function() {

        self.$router.push({ path: '/kirjaudu-sisaan' }).catch(() => {})

      }).catch(function(error) {

        console.log(error)

      });

    }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.formWrapper {
  width: 100%;
  min-height: 500px;
  margin: 0 auto;
  position: relative;
  padding: 50px 0;

  &:before {
    position: absolute;
    height: 600px;
    width: 50%;
    left: 0;
    top: 0;
    display: block;
    content: "";
    background: url('../assets/pisarat-orange.svg') top left;
  }

  &:after {
    position: absolute;
    height: 600px;
    width: 50%;
    right: 0;
    bottom: 0;
    display: block;
    content: "";
    background: url('../assets/pisarat-turqoise.svg') top left;
  }

  .form {
    display: block;
    width: 95%;
    max-width: 980px;
    border-radius: 28px;
    min-height: 500px;
    margin: 0 auto;
    background: white;
    z-index: 2;
    position: relative;
    padding: 30px;
    box-shadow: 2px 2px 80px 0px rgba(0,0,0,0.05);

    .sendForm {
      width: 100%;
      height: 50px;
      background: #8CD790;
      color: white;
      border-radius: 4px;
      margin: 0 auto;
      display: block;
      font-weight: 700;
      font-size: 22px;
    }

    .sendFormLoading {
      font-size: 0;

      &:after {
        font-size: 22px;
        content: "Odota hetki..."
      }

    }

    header {
      width: 100%;
      height: 100px;
      margin: 0 0 30px 0;
      position: relative;

      .logo {
        width: auto;
        display: block;
        height: 100px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
      }

      .logOut {
        position: absolute;
        right: 0px;
        width: 50px;
        height: 50px;
        top: 50%;
        transform: translate(0, -50%);
        background: url("../assets/logout.svg") center center no-repeat;
        background-size: 100% auto;
        cursor: pointer;
      }

    }

    h1 {
      width: 100%;
      font-weight: 700;
      font-size: 28px;
      margin: 0 0 10px 0;
      padding: 0;
    }

    h2 {
      width: 70%;
      font-weight: 400;
      font-size: 18px;
      margin: 0 0 30px 0;
      padding: 0;
    }

    .qWrapper {
      //border-bottom: 1px solid #eaeaea;
      background: #f8f8f8;
      padding: 20px;
      margin: 0 0 20px 0;
      //padding: 0 0 20px 0;
      min-height: 10px;
      position: relative;
      border-radius: 12px;

      &:after {
        clear: both;
        display: block;
        content: "";
      }

      label {
        width: 50%;
        display: block;
        min-height: 10px;
      }

      input[type="text"] {
        margin: 5px 0 0 0;
        background: white;
        padding: 0 10px;
      }

      select {
        background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjEuNDEgNC42NyAyLjQ4IDMuMTggMy41NCA0LjY3IDEuNDEgNC42NyIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIzLjU0IDUuMzMgMi40OCA2LjgyIDEuNDEgNS4zMyAzLjU0IDUuMzMiLz48L3N2Zz4=) no-repeat 97% 50% white;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        outline: none;
        height: 50px;
        display: block;
        margin: 10px auto 0;
        border: none;
        width: 100%;
        padding: 5px;
        border-radius: 4px;
        font-size: 18px;
        padding: 0 0 0 15px;
      }

      textarea {
        width: 100%;
        height: 80px;
        border-radius: 4px;
        border: none;
        margin: 10px 0 0 0;
      }

      .inputWrapper {
        float: right;
        width: 50%;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;

        .checkbox {
          width: 80px;
          height: 40px;
          border-radius: 9999px;
          background: #eaeaea;
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translate(0, -50%);

          input[type="checkbox"] {
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0;
            cursor: pointer;
            display: block;
            z-index: 10;
            margin: 0;
            padding: 0;

            &:checked {

              ~ .checked {
                transform: translate3d(100%, 0, 0)
              }

              ~ .checkedBG {
                opacity: 1;
              }

            }

          }

          .checked {
            border-radius: 50%;
            background: white;
            width: 40px;
            height: 40px;
            position: absolute;
            top: 0;
            box-shadow: 2px 2px 20px 0px rgba(0,0,0,0.1);
            z-index: 2;
            transition: all 0.2s ease;
          }

          .checkedBG {
            position: absolute;
            z-index: 1;
            background: #8CD790;
            width: 100%;
            height: 100%;
            border-radius: 9999px;
            opacity: 0;
            transition: all 0.5s ease;
          }

        }

      }

    }

  }

}

</style>
